import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import vlog from '../../javascript/vlog';
import ContactsTable from './contacts_table';
import withV2HealthCheck from '../with_v2_health_check';

function Index({ userId }) {
  const [v2ProfileId, setV2ProfileId] = useState(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchV2Id = async () => {
      try {
        const { data, error: fetchError } = await window.supabaseClient
          .from('user_profiles')
          .select('profile_id')
          .eq('user_migrate_id', userId)
          .single();

        if (fetchError || !data?.profile_id) {
          vlog.error('Error fetching V2 profile ID:', fetchError);
          setError(true);
          setLoading(false);
          return;
        }

        setV2ProfileId(data.profile_id);
        setLoading(false);
      } catch (err) {
        vlog.error('Unexpected error fetching V2 ID:', err);
        setError(true);
        setLoading(false);
      }
    };

    fetchV2Id();
  }, [userId]);

  if (loading) return null;

  if (error) {
    return (
      <div className="alert alert-warning">
        Under Maintenance: please come back later.
      </div>
    );
  }

  return (
    <ContactsTable
      v2ProfileId={v2ProfileId}
      v1UserId={userId}
    />
  );
}

Index.propTypes = {
  userId: PropTypes.number.isRequired,
};

export default withV2HealthCheck(Index);
